import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function SlaContentReducer(state = initialState.slaContent, action: any) {
  switch (action.type) {
    case types.SAVE_SLACONTENT_SUCCESS:
      return action.slaContent;
    default:
      return state;
  }
}
